// extracted by mini-css-extract-plugin
export default {"spinner":"loading_spinner__Bo5Xe","sk-bouncedelay":"loading_sk-bouncedelay__EpWwt","bounce1":"loading_bounce1__BVyJM","bounce2":"loading_bounce2__JXd0E"};